import { DatePicker, Select, Skeleton } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useQuery } from "react-query";
import { columnChartConfigurationOptions } from "../../config";
import HTTP from "../../services/httpService";
import { disableFutureDates } from "../../services/util";
const { Option } = Select;

function BugByProject() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [assignee, setAssignee] = useState([]);
    const [barChartData, setbarChartData] = useState([]);
    const [defaultYear, setDefaultYear] = useState(moment());
    const [formData, setFormData] = useState({
        staff_id,
        range_year: moment().get("year"),
        workauthor_id: "",
    });

    const {
        status: assigneeStatus,
        data: assigneeRes,
        refetch: fetchWorkLogAuthor,
    } = useQuery(
        "assignee",
        async () => {
            return await HTTP("/analytics/getJiraAssignees", { staff_id });
        },
        { enabled: false },
    );

    const {
        status: barChartStatus,
        data: barChartDataRes,
        refetch: fetchChart,
    } = useQuery(
        "bugByProject",
        async () => {
            return await HTTP("/analytics/getJiraBugsByProject", {
                ...formData,
            });
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        fetchWorkLogAuthor();
        fetchChart();
    }, []);

    useEffect(() => {
        fetchChart();
    }, [formData]);

    useEffect(() => {
        if (assigneeStatus === "success") setAssignee(assigneeRes.data);
    }, [assigneeStatus, assigneeRes]);

    useEffect(() => {
        if (barChartStatus === "success") setbarChartData(barChartDataRes.data);
    }, [barChartStatus, barChartDataRes]);

    function handleYearChange(date, dateString) {
        const yearSelected = dateString || moment().get("year");
        setDefaultYear(dateString === "" ? moment() : moment(dateString));
        const updatedFormData = {
            ...formData,
            range_year: yearSelected,
        };
        setFormData(updatedFormData);
    }

    /* async function handleProjectSelectionChange(e) {
		let project_id = -1;
		if (e !== undefined) {
			[project_id] = e.split("#");
		}

		const updatedFormData = {
			...formData,
			project_id,
		};
		setFormData(updatedFormData);
	} */

    function handleAssigneeSelectionChange(e) {
        let workauthor_id = "";
        if (e !== undefined) {
            [workauthor_id] = e.split("#");
        }

        const updatedFormData = {
            ...formData,
            workauthor_id,
        };
        setFormData(updatedFormData);
    }

    return (
        <>
            <div className="chart-selection-options">
                <DatePicker
                    className="year-picker"
                    defaultValue={defaultYear}
                    onChange={handleYearChange}
                    picker="year"
                    allowClear={false}
                    disabledDate={disableFutureDates}
                />
                <Select
                    allowClear
                    showSearch
                    placeholder="Work-log Author"
                    onChange={handleAssigneeSelectionChange}
                    className="jira-dashboard-select"
                >
                    {assignee.map((e) => (
                        <Option key={`${e.assignee_id}#${e.assignee_name}`}>
                            {e.assignee_name}
                        </Option>
                    ))}
                </Select>
            </div>
            {barChartData.length > 0 ? (
                <Chart
                    legendToggle
                    className="charts"
                    chartType="ColumnChart"
                    height="95vh"
                    options={{
                        ...columnChartConfigurationOptions,
                        title: "Bugs By Project",
                        isStacked: true,
                    }}
                    data={barChartData}
                />
            ) : (
                <Skeleton />
            )}
        </>
    );
}

export default BugByProject;
